import { nextAPI } from './Axios'
import { getErrorMessage } from '../helpers/utils'

export const CartFecther = (url) => {
    if (url === '/cart') url = url + `?${Date.now()}`
    return nextAPI.get(url).then((res) => res.data)
}

/**
 * @link https://github.com/woocommerce/woocommerce-blocks/blob/trunk/src/StoreApi/docs/cart-items.md
 */

export const CartAPI = {
    getCart: '/get-cart',
    // getCart: '/cart',

    async deleteCart() {
        try {
            const { data } = await nextAPI.delete('/cart')
            return data
        } catch (e) {
            return getErrorMessage(e)
        }
    },

    async duplicateOrder(keys) {
        const { data } = await nextAPI.post('/cart?action=duplicateOrder', keys)
        return data
    },

    async getCheckout() {
        try {
            const { data } = await nextAPI.get('/cart?action=checkout')
            return data
        } catch (e) {
            return getErrorMessage(e)
        }
    },

    async getFreshCheckout() {
        const { data } = await nextAPI.get('/cart?action=freshCheckout')
        return data
    },

    async getForceCheckout() {
        try {
            const { data } = await nextAPI.get('/cart?action=checkout')
            return data
        } catch (e) {
            return this.getFreshCheckout()
        }
    },

    async removeItem(key) {
        await nextAPI.delete(`cart-action/items/${key}`)
    },

    async removeItems(keys) {
        const { data } = await nextAPI.post('cart-action/delete-items', {
            keys,
        })
        return data
    },

    async removeCoupon(coupon) {
        try {
            const { data } = await nextAPI.delete(
                `cart-action/coupons/${coupon}`,
            )
            return data
        } catch (e) {
            return getErrorMessage(e)
        }
    },

    async deleteItem() {
        try {
            const { data } = await nextAPI.delete('/cart')
            return data
        } catch (e) {
            return getErrorMessage(e)
        }
    },

    async deleteCartDB() {
        try {
            const { data } = await nextAPI.delete('/cart-action/delete-cart')
            return data
        } catch (e) {
            return getErrorMessage(e)
        }
    },
}
